import React from 'react';

import { IIconProps } from './constants';

export const StatsIcon = ({
  size = undefined,
  height = 24,
  width = 24,
  strokeWidth = 2,
  title = '',
  ariaLabel = '',
  ariaHidden = false,
}: IIconProps) => (
  <svg
    width={size || width}
    height={size || height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={ariaLabel}
    aria-hidden={ariaHidden}
  >
    {title && <title>{title}</title>}
    <path
      d="M2 15.6667C2 15.1144 2.44772 14.6667 3 14.6667H6C6.55228 14.6667 7 15.1144 7 15.6667V21.6667H3C2.44772 21.6667 2 21.219 2 20.6667V15.6667Z"
      stroke="currentcolor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M7 9.66669C7 9.1144 7.44772 8.66669 8 8.66669H12V21.6667H7V9.66669Z"
      stroke="currentcolor"
      strokeWidth={strokeWidth}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.66669C12 3.1144 12.4477 2.66669 13 2.66669H16C16.5523 2.66669 17 3.1144 17 3.66669V20.6667C17 21.219 16.5523 21.6667 16 21.6667H13C12.4477 21.6667 12 21.219 12 20.6667V3.66669Z"
      stroke="currentcolor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M17 8.66669C17 8.1144 17.4477 7.66669 18 7.66669H21C21.5523 7.66669 22 8.1144 22 8.66669V20.6667C22 21.219 21.5523 21.6667 21 21.6667H17V8.66669Z"
      stroke="currentcolor"
      strokeWidth={strokeWidth}
    />
  </svg>
);
